import * as XLSX from 'xlsx'

export const SUPPORTED_IMPORT_EXTENSIONS = ['csv', 'xlsx', 'xls']

export function getFileExtension(filename = '') {
  const match = String(filename || '').toLowerCase().match(/\.([^.]+)$/)
  return match ? match[1] : ''
}

export function isSupportedImportFile(filename) {
  return SUPPORTED_IMPORT_EXTENSIONS.includes(getFileExtension(filename))
}

const hasValue = value => String(value === null || value === undefined ? '' : value).trim() !== ''

export function worksheetRows(worksheet) {
  const rows = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    defval: '',
    blankrows: true,
    raw: false,
  })
  const range = worksheet['!ref'] ? XLSX.utils.decode_range(worksheet['!ref']) : null
  return range && range.s.r > 0 ? Array.from({ length: range.s.r }, () => []).concat(rows) : rows
}

export function getNonEmptyWorksheets(workbook) {
  return workbook.SheetNames.map(name => ({
    name,
    rows: worksheetRows(workbook.Sheets[name]),
  })).filter(sheet => sheet.rows.some(row => row.some(hasValue)))
}

export function rowsToImportData(rows, sourceLabel = 'La feuille') {
  const nonEmptyRows = rows.map((values, index) => ({
    values,
    sourceRow: index + 1,
  })).filter(row => row.values.some(hasValue))

  if (nonEmptyRows.length < 2) {
    throw new Error(`${sourceLabel} doit contenir une ligne d'en-tête et une ligne de données`)
  }

  const headers = nonEmptyRows[0].values.map(value => String(value).trim().replace(/^\uFEFF/, ''))
  if (!headers.some(hasValue)) {
    throw new Error(`${sourceLabel} ne contient pas d'en-tête utilisable`)
  }

  const data = nonEmptyRows.slice(1).map(({ values, sourceRow }) => {
    const row = { sourceRow }
    headers.forEach((header, index) => {
      if (header) row[header] = values[index] === null || values[index] === undefined ? '' : String(values[index])
    })
    return row
  })

  return { headers: headers.filter(Boolean), data }
}

export function readWorkbook(buffer) {
  return XLSX.read(buffer, {
    type: 'array',
    cellFormula: true,
    cellText: true,
  })
}
